/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecommendationItem } from './recommendationItem';


/**
 * A block listing recommended actions derived from the insight.
 */
export interface RecommendationsBlock { 
    /**
     * Discriminator identifying this block as a recommendations list.
     */
    type?: RecommendationsBlock.TypeEnum;
    /**
     * Ordered list of recommended actions.
     */
    items: Array<RecommendationItem>;
}
export namespace RecommendationsBlock {
    export const TypeEnum = {
        Recommendations: 'recommendations'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


